import script from "./logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./logo.vue?vue&type=script&setup=true&lang=ts"

import "./logo.vue?vue&type=style&index=0&id=0bf4cf0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf4cf0a"]])

export default __exports__